import { getLocationFromPath } from './locationUtils';

const LS_RESTAURANT_NAME = 'RESTAURANT_NAME';

// Default/fallback names and mapping between shorthand and full display name
export const DEFAULT_RESTAURANT_NAME = 'Mimosa Brookfield';
export const RESTAURANT_NAMES: Record<string, string> = {
  'brookfield': 'Mimosa Brookfield',
  'franklin': 'Mimosa Franklin',
};

function safeGetItem(key: string): string | null {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(key);
}

function safeSetItem(key: string, value: string) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(key, value);
}

/**
 * Get restaurant name from localStorage, or default if none set.
 */
export function getRestaurantName(): string {
  // Try path-based detection first (per-tab/per-URL)
  const pathLocation = (typeof window !== 'undefined') ? getLocationFromPath() : null;

  if (pathLocation) {
    return pathLocation;
  }

  // Fall back to localStorage value
  const location = safeGetItem('restaurantLocation');

  if (location) {
    // 1. If the location string is a shorthand key like "brookfield" or "franklin",
    //    map it to the full, user-facing name.
    const mappedName = RESTAURANT_NAMES[location.toLowerCase() as keyof typeof RESTAURANT_NAMES];
    if (mappedName) {
      return mappedName;
    }

    // 2. Otherwise assume that the value stored in localStorage is already the
    //    full display name (e.g. "Mimosa Brookfield" / "Mimosa Franklin") and
    //    use it directly.
    return location;
  }

  // 3. Fallbacks – check for an explicitly stored name or resort to the default.
  return safeGetItem(LS_RESTAURANT_NAME) || DEFAULT_RESTAURANT_NAME;
}

/**
 * Get restaurant location from localStorage
 */
export function getRestaurantLocation(): string {
  return safeGetItem('restaurantLocation') || '';
}

/**
 * Persist restaurant name to localStorage
 */
export function setRestaurantName(name: string) {
  safeSetItem(LS_RESTAURANT_NAME, name.trim());
} 